import { useAuth } from '../../AuthContext'
import { useCasquette } from '../../contexts/casquette'
import RinaContextCard from '../../components/RinaContextCard'
import PageHub from '../../components/PageHub'
import AideContactPage from './AideContactPage'
import { ROUTES } from '../../routes'

/** Page « Nous contacter » (S56) : /account/aide/contact. */
export default function PageAideContact() {
  const { user } = useAuth()
  const { hubMode } = useCasquette()
  return (
    <PageHub retour={{ label: 'Aide', vers: ROUTES.compte.aide }}>
      <div className="animate-fade-up">
        <RinaContextCard title="Nous contacter" message="WhatsApp pour une réponse rapide, l'e-mail pour ce qui demande un dossier." />
        <AideContactPage tc="text-ink" ts="text-ink/60" cardBg="bg-card border-card-border" hubMode={hubMode} user={user} />
      </div>
    </PageHub>
  )
}
